// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".message-history-other-user-list .other-user[data-v-c7921b74]{border-bottom:1px solid #9b9b9b}.message-history-other-user-list .other-user[data-v-c7921b74]:last-child{border-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
